// Generated by Melange

import * as Buhta_landing__Content from "../../../../core/Content.js";
import * as Buhta_landing__JobForm from "./JobForm.js";
import * as Buhta_landing__JobUtils from "./JobUtils.js";
import * as Buhta_landing__Route from "../../../../Route.js";
import * as JsxRuntime from "react/jsx-runtime";

function Job(Props) {
  const currentRoute = Buhta_landing__Route.ofUrl(Buhta_landing__Route.useUrl(undefined));
  const match = Buhta_landing__Content.Context.useContent(undefined);
  const jobCategories = match[0].jobCategories;
  const job = Buhta_landing__JobUtils.getCurrentJob(currentRoute, jobCategories);
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("h2", {
        children: job.name,
        className: "h4 lg:h2 text-black-landing"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("p", {
                children: "Специальность",
                className: "paragraph-small text-gray-landing"
              }),
              JsxRuntime.jsx("p", {
                children: job.speciality,
                className: "paragraph text-black-landing mt-1"
              })
            ],
            className: "w-49"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("p", {
                children: "Город",
                className: "paragraph-small text-gray-landing"
              }),
              JsxRuntime.jsx("p", {
                children: job.city,
                className: "paragraph text-black-landing mt-1"
              })
            ],
            className: "mt-4 lg:mt-0 lg:w-49"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("p", {
                children: "Опыт",
                className: "paragraph-small text-gray-landing"
              }),
              JsxRuntime.jsx("p", {
                children: job.experience,
                className: "paragraph text-black-landing mt-1"
              })
            ],
            className: "mt-4 lg:mt-0 lg:w-49"
          })
        ],
        className: "block lg:flex justify-between mt-6 lg:mt-10"
      }),
      JsxRuntime.jsx("p", {
        children: job.description,
        className: "paragraph text-black-landing mt-6 lg:mt-10 whitespace-pre-line"
      }),
      JsxRuntime.jsx("hr", {
        className: "text-divider mt-6 lg:mt-10"
      }),
      JsxRuntime.jsx("h6", {
        children: "Требования",
        className: "h6 text-black-landing mt-6 lg:mt-10"
      }),
      JsxRuntime.jsx("p", {
        children: job.requirements,
        className: "paragraph text-black-landing mt-2 whitespace-pre-line"
      }),
      JsxRuntime.jsx("h6", {
        children: "Обязанности",
        className: "h6 text-black-landing mt-6 lg:mt-10"
      }),
      JsxRuntime.jsx("p", {
        children: job.responsibilities,
        className: "paragraph text-black-landing mt-2 whitespace-pre-line"
      }),
      JsxRuntime.jsx("h6", {
        children: "Условия",
        className: "h6 text-black-landing mt-6 lg:mt-10"
      }),
      JsxRuntime.jsx("p", {
        children: job.conditions,
        className: "paragraph text-black-landing mt-2 whitespace-pre-line"
      }),
      JsxRuntime.jsx("hr", {
        className: "text-divider mt-6 lg:mt-10"
      }),
      JsxRuntime.jsx("h4", {
        children: "Расскажите о себе",
        className: "h4 text-black-landing mt-6 lg:mt-10"
      }),
      JsxRuntime.jsx(Buhta_landing__JobForm.make, {})
    ],
    className: "pt-10 lg:pt-0 px-6 sm:px-48 lg:px-0"
  });
}

const make = Job;

export {
  make,
}
/* Buhta_landing__Content Not a pure module */
